import * as yup from "yup";

import { messagesConstants } from "@/constants";

export const updateEventSocialSharingFormSocialSharingUpdateEventFormSchema = yup.object({
    facebookText: yup.string().required(messagesConstants.inputsMsgs.text),
    facebookTitle: yup.string().required(messagesConstants.inputsMsgs.title),
    twitterText: yup.string().required(messagesConstants.inputsMsgs.text),
});
